module.exports = __webpack_public_path__ + "img/solutions_footer.0b2aab99.png";